import { useCallback } from 'react'

import { AcquisitionDataLayerPayload } from '@atoms/acquisitionTracking'

interface SecuredLoanSubmitEvent {
    event: 'form-submit-loans-secured'
}

interface SecuredLoanValidationErrorEvent {
    event: 'secured_validation_errors'
    name_values: string[]
    names: string[]
}

interface AcquisitionFormEvent extends AcquisitionDataLayerPayload {}

type SupportedEventData =
    | SecuredLoanSubmitEvent
    | SecuredLoanValidationErrorEvent
    | AcquisitionFormEvent

const useGoogleTagManager = () => {
    const dataLayer =
        typeof window !== 'undefined' && typeof window.dataLayer !== 'undefined'
            ? window.dataLayer
            : []

    const send = useCallback((eventData: SupportedEventData) => {
        if (dataLayer != null) {
            dataLayer.push(eventData)
        } else {
            console.log('[GTM Event]', eventData)
        }
    }, [])

    return send
}

export default useGoogleTagManager
